// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","711":"component---src-pages-mdx-slug-js","883":"component---src-pages-404-js","976":"dd833c054ac44fc065c1430e4e13dd9714f600e2"}[chunkId] + "-" + {"678":"701ea9677c180a87a45a","711":"b597d431edf7c4a5b241","883":"da22dc2b9636e9c35ddb","976":"177ecff3164f31463ade"}[chunkId] + ".js";
};